import React, { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";
import { Controller } from "react-hook-form";
import API from "src/services/api";

const TagSelectorForm = ({ id, control, setValue, watch, swipetype_id }) => {
  const [data, setData] = useState([]);
  const selectedLabels = watch(id, []);

  const loadItems = async () => {
    const items = await API.getTagsOfSwipetype(swipetype_id);
    if (items.status === true) {
      console.log("DATA", items.data);
      setData(items.data);
    }
  };

  const toggle = (value) => {
    setValue(
      id,
      selectedLabels.includes(value)
        ? selectedLabels.filter((l) => l !== value)
        : [...selectedLabels, value]
    );
  };

  useEffect(() => {
    loadItems();
  }, [swipetype_id]);

  if (data.length === 0) {
    return "No data";
  }

  return data.map((i) => {
    return (
      <Controller
        name={id}
        control={control}
        // defaultValue={selectedLabels}
        render={({ field }) => (
          <React.Fragment>
            <h2>{i.name}</h2>
            <p style={{ fontSize: "120%" }}>
              {i.tags.map((j) => {
                return (
                  <React.Fragment key={j.id}>
                    <Badge
                      style={{ marginRight: "5px", cursor: "pointer" }}
                      bg={field.value?.includes(j.id) ? "success" : "secondary"}
                      onClick={() => toggle(j.id)}
                    >
                      {j.name}
                    </Badge>
                  </React.Fragment>
                );
              })}
            </p>
          </React.Fragment>
        )}
      />
    );
  });
};

export default TagSelectorForm;
